"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getPostShowEmailPreviewData = void 0;
const creator_1 = require("../creator");
const getPostShowEmailPreviewData = (config, builderId, draftId, assetsEndpoint) => {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z, _0, _1, _2;
    const { selectedColors } = (0, creator_1.getColorConfig)(config);
    const imageVariant = config.fields.type.content === 0
        ? "c"
        : [1, 3, 4].includes(config.fields.type.content)
            ? "b"
            : "a";
    const bannerUrl = `${assetsEndpoint}/preview/${builderId}/${draftId}/${imageVariant}`;
    const sociallinks = (0, creator_1.getSocialLinks)(config);
    const filteredSocialLinks = Object.fromEntries(Object.entries(sociallinks).filter(([k, v]) => !!v));
    return {
        artistName: config.artistName || "",
        eventId: builderId,
        selectedColors: selectedColors || { dark: "#666", light: "#fff" },
        eventType: config.fields.type.content,
        bannerUrl,
        ...(!!((_a = config.fields.postShowEmailMerchEnabled) === null || _a === void 0 ? void 0 : _a.content) &&
            !!((_b = config.fields.merchandise.content) === null || _b === void 0 ? void 0 : _b.length) && {
            merch: {
                header: ((_d = (_c = config.fields.postShowEmailMerchHeadline) === null || _c === void 0 ? void 0 : _c.content) === null || _d === void 0 ? void 0 : _d.en) || "",
                items: (_f = (_e = config.fields.merchandise) === null || _e === void 0 ? void 0 : _e.content) === null || _f === void 0 ? void 0 : _f.slice(0, 3),
                ...(config.merchandiseUrl &&
                    ((_h = (_g = config.fields.postShowEmailMerchCtaLabel) === null || _g === void 0 ? void 0 : _g.content) === null || _h === void 0 ? void 0 : _h.en) &&
                    !((_j = config.fields.postShowEmailMerchDisableCta) === null || _j === void 0 ? void 0 : _j.content) && {
                    ctalabel: (_l = (_k = config.fields.postShowEmailMerchCtaLabel) === null || _k === void 0 ? void 0 : _k.content) === null || _l === void 0 ? void 0 : _l.en,
                    url: config.merchandiseUrl,
                }),
            },
        }),
        main: {
            header: ((_o = (_m = config.fields.postShowEmailHeadline) === null || _m === void 0 ? void 0 : _m.content) === null || _o === void 0 ? void 0 : _o.en) || "",
            body: (_q = (_p = config.fields.postShowEmailBody) === null || _p === void 0 ? void 0 : _p.content) === null || _q === void 0 ? void 0 : _q.en,
            ctalabel: (_s = (_r = config.fields.postShowEmailCtaLabel) === null || _r === void 0 ? void 0 : _r.content) === null || _s === void 0 ? void 0 : _s.en,
            url: (_u = (_t = config.fields.postShowEmailCta) === null || _t === void 0 ? void 0 : _t.content) === null || _u === void 0 ? void 0 : _u.en,
        },
        ...(((_w = (_v = config.fields.postRegistrationAlbum) === null || _v === void 0 ? void 0 : _v.content) === null || _w === void 0 ? void 0 : _w.image) &&
            ((_x = config.fields.postShowEmailReleaseEnabled) === null || _x === void 0 ? void 0 : _x.content) && {
            streaming: {
                ...(_y = config.fields.postRegistrationAlbum) === null || _y === void 0 ? void 0 : _y.content,
                header: ((_0 = (_z = config.fields.postShowEmailReleaseHeadline) === null || _z === void 0 ? void 0 : _z.content) === null || _0 === void 0 ? void 0 : _0.en) || "",
                image: (_2 = (_1 = config.fields.postRegistrationAlbum) === null || _1 === void 0 ? void 0 : _1.content) === null || _2 === void 0 ? void 0 : _2.image,
            },
        }),
        socials: filteredSocialLinks,
    };
};
exports.getPostShowEmailPreviewData = getPostShowEmailPreviewData;
//# sourceMappingURL=index.js.map